import { render } from "./ProjectPicker.vue?vue&type=template&id=af88b27c&scoped=true"
import script from "./ProjectPicker.vue?vue&type=script&lang=js"
export * from "./ProjectPicker.vue?vue&type=script&lang=js"

import "./ProjectPicker.vue?vue&type=style&index=0&id=af88b27c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af88b27c"]])

export default __exports__